export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-bad-it.625e8ceb.svg";